import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { InfoWindow } from "@vis.gl/react-google-maps";
import {updatePreferedAddress} from '../../Actions/PreferedAddress.action';
import { translate } from '../../Services/translation';
import { googleAnalytics } from '../../Services/googleAnalytics';
import { setAdvancedMarkerIsOpen } from '../../Actions/ResellerMapList.action';

export default function GoogleMapsInfoWindow({ advancedMarker, dealer }) {
  const dispatch = useDispatch();
  const selectedInfo = useSelector((state) => state.preferedAddress.selectedAddress);

  const setPreferedDealer = (address) => {
    if (address.addressId !== undefined) {
      let streetAddress = address.streetName;
      streetAddress += address.zipCode ? " " + address.zipCode : "";
      streetAddress += address.city ? " " + address.city : "";

      var ClickCollectCustomer = {
        OrganizationId: address.organizationId,
        OrganizationName: address.companyName,
        Email: address.email,
        HomePage: address.homePage,
        Address: streetAddress,
        ProductAssortment: address.productAssortment,
        ShopName: address.shopName
      }
      dispatch(updatePreferedAddress(ClickCollectCustomer));
    }
    else
    {
      window.localStorage.removeItem('preferredclickcollectaddress');
    }
  }

  const addPreferedAddress = (event, address) => {
    if (event.target.checked == true) {
      dispatch(updatePreferedAddress(address));
    }
    else {
      dispatch(updatePreferedAddress(null));
    }
  }

  const sendDataLayer = (dealerName, click) => {
      googleAnalytics({
          'event': 'dealerLocatorPopup',
          'dealer': dealerName,
          'click': click
      });
  }

  return (
    <InfoWindow headerDisabled anchor={advancedMarker} onCloseClick={() => dispatch(setAdvancedMarkerIsOpen(false))}>
    <div className="map-address">
      <h4 className="map-address--header">{dealer.shopName}</h4>
        <p className="address">{dealer.streetName}, {dealer.zipCode} {dealer.city}</p>
        {dealer.telephone ? (
          <p>
            <a onClick={() => sendDataLayer(dealer.shopName, "phone-number")} href={"tel:" + dealer.telephone}>{dealer.telephone}</a>
          </p>) : ''}

        {dealer.homePage ? (
          <p>
            <a onClick={() => sendDataLayer(dealer.shopName, "home-page")} href={dealer.homePage} target="_blank">{dealer.homePage}</a>
          </p>) : ''}
  
        {dealer.email ? (
          <p>
            <a onClick={() => sendDataLayer(dealer.shopName, "email")} href={"mailto:" + dealer.email}> {translate('dealerlocator.sendmessage')}</a>
          </p>) : ''}

        {dealer.streetName ? (
          <p>
            <a onClick={() => sendDataLayer(dealer.shopName, "map")} href={`https://www.google.com/maps/?q=${dealer.latitude},${dealer.longitude}`} 
              target="_blank">{translate('dealerlocator.findhere')}</a>
          </p>) : ''}

        <div className="prefered-retailer-map custom-checkbox">
          <input onClick={() => {
            sendDataLayer(dealer.shopName, "prefered")
            setPreferedDealer(dealer)
          }} 
          type="checkbox"
            checked={selectedInfo['addressId'] == dealer['addressId']}
            onChange={(event) =>
              addPreferedAddress(event, dealer)
            }>
          </input>
          <label className="">
            {translate('map.preferedretailer')}
          </label>
        </div>
    </div>
  </InfoWindow>
  );
};